module.exports = __webpack_public_path__ + "static/media/3.36e55ccb.svg";